var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c("gg-card-header", [
                _vm._v(" Latest web server error log messages: ")
              ]),
              _c(
                "gg-card-text",
                [
                  _c("v-textarea", {
                    attrs: {
                      value: _vm.parsedToString,
                      loading: _vm.pending,
                      "loader-height": "5",
                      outlined: "",
                      readonly: "",
                      rows: "15"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }